import React, { ChangeEvent } from 'react';
import { DebouncedInput } from '@app/components/DebouncedInput';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { useRouterIntentState } from '@app/state/routerIntentStore';
import { useWalletBalance } from '@app/hooks/thirdweb/useWalletBalance';
import { Icon } from '@app/components/Icon';

export const SourceAmount = () => {
  const {
    sourceNetwork,
    sourceToken,
    sourceAmount,
    actions: { setSourceAmount }
  } = useRouterIntentState();

  const { data: balance } = useWalletBalance(sourceNetwork, sourceToken);

  const handleChange = (inputValue: string) => {
    // Regular expression to allow only numbers and decimals
    const regex = /^\d*\.?\d*$/;

    if (regex.test(inputValue)) {
      setSourceAmount(inputValue);
    }
  };

  return (
    <Box w="100%">
      <HStack
        justifyContent="space-between"
        mt="18px"
        w="100%"
        sx={{
          paddingRight: '14px',
          borderRadius: '10px',
          border: '1px solid',
          borderColor: 'gray.5',
          background: 'black'
        }}
      >
        <DebouncedInput
          type="text"
          textAlign="left"
          onlyNumbers
          amount={sourceAmount}
          disabled={!sourceNetwork || !sourceToken}
          onChange={handleChange}
        />
        <Button
          variant="tertiary"
          onClick={() => {
            if (balance === undefined) {
              return;
            }

            setSourceAmount(balance.displayValue);
          }}
          sx={{
            color: 'orange',
            bg: 'gray.2',
            width: 'fit-content',
            fontSize: '14px',
            padding: '8px 14px'
          }}
        >
          MAX
        </Button>
      </HStack>
      <HStack justify="space-between" mt={2}>
        {balance && sourceAmount && +sourceAmount > +balance.displayValue ? (
          <HStack>
            <Icon
              name="infoCircle"
              style={{ width: 16, height: 16, color: '#FFAD8F' }}
            />
            <Text fontSize="12px" color="txt.accent">
              Insufficient balance
            </Text>
          </HStack>
        ) : (
          <div />
        )}
        <HStack>
          <Text
            color="neutral.500"
            fontSize="12px"
            fontWeight="400"
            lineHeight="18px"
            letterSpacing="-0.18px"
          >
            Balance:
          </Text>
          <Text
            color="neutral.400"
            fontSize="12px"
            fontWeight="400"
            lineHeight="18px"
            letterSpacing="-0.18px"
          >
            {sourceToken && balance ? balance.displayValue : 'n/a'}
          </Text>
        </HStack>
      </HStack>
    </Box>
  );
};
